Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AddToCartButton3216318065",
  {"addToCartButton":"AddToCartButton3216318065--addToCartButton","root":"AddToCartButton3216318065--root","buttonAddToCartBackground":"'\"--gallery_addToCartButtonBackgroundColor\"'","buttonAddToCartColor":"'\"fallback(color(--gallery_addToCartButtonTextColor), color(color-1))\"'","buttonAddToCartFont":"'\"fallback(font(--gallery_addToCartButtonTextFont), font({theme: 'Body-M', size: '15px'}))\"'","buttonAddToCartBorderWidth":"'\"fallback(font(--gallery_addToCartButtonBorderSize), string(0))\"'","buttonAddToCartBorderColor":"'\"fallback(color(--gallery_addToCartButtonBorderColor), color(color-5))\"'","buttonAddToCartBorderRadius":"'\"fallback(font(--gallery_addToCartButtonCornersRadius), unit(0,px))\"'"},
  "",
  8,
  "AddToCartButton3216318065"
);

